import { useTheme } from 'styled-components';

export const UndoIcon: React.FC<{ className?: string }> = ({ className }) => {
  const theme = useTheme();
  return (
    <svg width="14" height="6" viewBox="0 0 14 6" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M6.90938 0.658036C5.16558 0.658036 3.5863 1.30949 2.36893 2.36893L0 0V5.92233H5.92233L3.54023 3.54023C4.45491 2.77691 5.61963 2.30313 6.90938 2.30313C9.23883 2.30313 11.2195 3.82319 11.9105 5.92233L13.47 5.40906C12.5553 2.65189 9.96925 0.658036 6.90938 0.658036Z"
        fill={theme.secondary.softBlue1}
      />
    </svg>
  );
};
